import { Component, State, h, ComponentInterface, Prop } from "@stencil/core";
import { AppHomeType } from '../app-home/app-home-types';

@Component({
  tag: 'app-home-restaurante',
  styleUrl: 'app-home-restaurante.css',
  shadow: false,
})
export class AppHome implements ComponentInterface {
  @Prop() firmType: AppHomeType;

  render() {
    return <app-home firmType={AppHomeType.restaurante}></app-home>
  }
}